import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { getTimeline } from "../services/timeline";

export const useTimeline = (params: {
  orderId: string;
  timelineLimit: number;
}) =>
  useQuery({
    queryFn: getTimeline,
    queryKey: ["orders-timeline", params],
    retry: 2,
    staleTime: 30000,
  });

// Marks an order's timeline as stale so it's refetched (now if it's open,
// otherwise the next time the Timeline tab is shown).
export const useInvalidateOrderTimeline = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (orderId: string) =>
      queryClient.invalidateQueries({
        queryKey: ["orders-timeline", { orderId }],
      }),
    [queryClient],
  );
};
